/**
 * Component for selecting a plant when multiple matches are found
 */

import React from 'react';
import type { Plant } from '../types/breeding';

interface PlantSelectorProps {
  plants: Plant[];
  onSelect: (plant: Plant) => void;
  title?: string;
  description?: string;
}

export function PlantSelector({
  plants,
  onSelect,
  title = 'Select Plant',
  description = 'Multiple plants found. Please select one:',
}: PlantSelectorProps) {
  return (
    <div className="form-card">
      <h2>{title}</h2>
      <p>{description}</p>
      <div className="results-area">
        {plants.map((plant) => (
          <div
            key={plant.Id}
            className="plant-card"
            onClick={() => onSelect(plant)}
            style={{ cursor: 'pointer' }}
          >
            <h3>
              {plant.TSID}
              {plant.IsMother && <span className="badge badge-mother">MOTHER</span>}
            </h3>
            <p>
              <strong>Strain:</strong> {plant.StrainName}
            </p>
            <p>
              <strong>Room:</strong> {plant.RoomName}
            </p>
            <p>
              <strong>Phase:</strong> {plant.GrowPhase}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
